import * as angular from "angular";
import {IController} from "angular";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";
import * as _ from "lodash";
import {FulfillmentAttemptModel} from "../../models/fulfillment-attempt.model";
import {LocationType} from "../../../commons/types/location.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class FulfillmentStepTableItemComponent implements IController {

  step: FulfillmentStepModel;
  isSelected: boolean;
  isExcluded: boolean;
  settings: any;
  onSelect: Function;

  public lastAttempt: FulfillmentAttemptModel;
  public locationTypes: typeof LocationType = LocationType;
  public stepPackagesLabels: string[] = [];
  public siteLabelsColorMap: {} = {};

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.splitService.getSiteLabels().forEach(label => {
      this.siteLabelsColorMap[label.name] = label.color;
    })
    this._getLastAttempt();
    this._initPackagesLabels();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.step && !changes.step.isFirstChange()) {
      this._getLastAttempt();
      this._initPackagesLabels();
    }
  }

  private _getLastAttempt() {
    this.lastAttempt = _.find(this.step?.attempts, (a) => {
      return a.referenceId === this.step.referenceId;
    });
  }

  private _initPackagesLabels() {
    this.stepPackagesLabels = [];
    this.step.itemsExt.forEach(item => {
      if (item.labels) {
        this.stepPackagesLabels = this.stepPackagesLabels.concat(item.labels)
      }
    });
    this.stepPackagesLabels = _.uniq(this.stepPackagesLabels);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepTableItem', {
    bindings: {
      step: '<',
      isSelected: '<',
      isExcluded: '<',
      settings: '<?',
      onSelect: '&'
    },
    template: require('./fulfillment-step-table-item.html').default,
    controller: FulfillmentStepTableItemComponent
  });
